import React from 'react';
export function FooterCTA() {
  const scrollToTop = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const formElement = document.getElementById('register-form');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return <section className="bg-white py-24 px-4 sm:px-6 lg:px-8 text-center border-t border-gray-100" data-id="element-70">
      <div className="max-w-3xl mx-auto" data-id="element-71">
        <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-8" data-id="element-72">
          Klaar om de band met je hond te versterken?
        </h2>

        <a href="#register-form" onClick={scrollToTop} className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-brand-coral hover:bg-brand-coralHover rounded-full shadow-[0_8px_20px_-6px_rgba(232,97,74,0.5)] hover:shadow-[0_12px_24px_-8px_rgba(232,97,74,0.6)] hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto" data-id="element-73">
          Ja, ik meld me gratis aan!
        </a>

        <p className="mt-6 text-sm text-gray-500" data-id="element-74">
          Beveiligde aanmelding via WebinarGeek. Je gegevens zijn veilig.
        </p>

        <div className="mt-8 flex flex-col items-center gap-3" data-id="element-75">
          <img src="https://cdn.magicpatterns.com/uploads/rbaXGkhTDaxoi6xgNcF27K/stresslessdogs_1_(1).jpg" alt="Amee van Stressless Dogs" className="w-16 h-16 rounded-full object-cover border-2 border-brand-mint/30 shadow-md" data-id="element-76" />
          <p className="text-sm text-gray-600 font-medium" data-id="element-77">
            Amee – Stressless Dogs
          </p>
        </div>
      </div>
    </section>;
}